import React from "react"
import { paths } from "../../routes/paths"
import { Link } from "react-router-dom"

const notificationsHeader = {
  opportunity_created: "You received a new application",
  opportunity_rejected_from_seeker: "Application was canceled",
  opportunity_accepted_from_provider: "Your application was added to favorites",
  opportunity_created_from_provider:
    "Your application was removed from favorites",
  opportunity_rejected_from_provider: "Your application was rejected",
  company_provider_likes_your_user: "Your profile was added to favorites",
  company_provider_unliked_your_user: "Your profile was removed from favorites",
  company_provider_likes_your_company:
    "company provider likes liked your company profile",
  company_provider_unliked_your_company:
    "company provider likes unliked your company profile",
  company_provider_likes_your_opportunity:
    "company provider likes liked your opportunity",
  company_provider_unliked_your_opportunity:
    "company provider likes unliked your opportunity",
  company_seeker_likes_your_user:
    "company seeker likes liked your professional profile",
  company_seeker_unliked_your_user:
    "company seeker unliked unliked your professional profile",
  company_seeker_likes_your_company:
    "company seeker likes liked your company profile",
  company_seeker_unliked_your_company:
    "company seeker likes unliked your company profile",
  company_seeker_likes_your_opportunity:
    "company seeker likes liked your opportunity",
  company_seeker_unliked_your_opportunity:
    "company seeker likes unliked your opportunity",
  individual_likes_your_user: "provider likes likes your professional profile",
  individual_unliked_your_user:
    "provider likes unliked your professional profile",
  individual_likes_your_company: "Your profile was added to favorites",
  individual_unliked_your_company: "Your profile was removed from favorites",
  individual_likes_your_opportunity: "Your opportunity was added to favorites",
  individual_unliked_your_opportunity:
    "Your opportunity was removed from favorites",
  attendee_created: "New resource member",
  attendee_canceled: "Resource member cancelation",
  your_post_has_a_new_comment: "Your post has a new comment",
  your_comment_has_a_new_reply: "Your comment has a new reply",
  your_comment_has_a_new_reaction: "Your comment has a new reaction",
  you_received_a_new_peer_circle_invitation:
    "You received a new Peer Circle invitation",
  your_peer_circle_invitation_was_accepted:
    "Peer Circle invitation accepted",
  your_peer_circle_invitation_was_declined:
    "Peer Circle invitation declined",
  your_post_has_a_new_reaction: "Your post has a new reaction",
  User_unliked_your_company: "Your profile was removed from favorites",
  User_likes_your_company: "Your profile was added to favorites",
  User_likes_your_opportunity: "Your opportunity was added to favorites",
  User_unliked_your_opportunity: "Your opportunity was removed from favorites",
  User_likes_your_user: "Your profile was added to favorites",
  User_unliked_your_user: "Your profile was removed from favorites",
  new_administrator_added: "A new administrator has been added to your account",
  opportunity_created_invited: "You received an opportunity invitation",
  employee_user_invited: "A new team member has been invited",
  employee_registered: "A new team member has joined",
}

const USER_APPLICATION_NAME_EMAIL_COLOR = "#b4182d"
const USER_APPLICATION_APPROVED_COLOR = "#4caf50"

const renderUserApplicationNotification = (notification) => {
  const { name, email, status } = notification.attached_object || {}
  const actionMatch = notification.body?.match(/^User application (\w+)/)
  const action = actionMatch?.[1] || status

  const nameEmailStyle = {
    color: USER_APPLICATION_NAME_EMAIL_COLOR,
    fontWeight: 600,
  }
  const approvedStyle = {
    color: USER_APPLICATION_APPROVED_COLOR,
    fontWeight: 600,
  }

  return (
    <p>
      User application{" "}
      <span style={action === "approved" ? approvedStyle : { fontWeight: 600 }}>
        {action}
      </span>
      {" - "}
      <span style={nameEmailStyle}>{name}</span>
      {" ("}
      <span style={nameEmailStyle}>{email}</span>
      {") - status: "}
      <span style={status === "approved" ? approvedStyle : { fontWeight: 600 }}>
        {status}
      </span>
    </p>
  )
}

const generateMessage = (
  userName,
  userType,
  userUuid,
  middleText,
  objectName,
  objectLink,
  objectType,
) => {
  const userLink =
    userType === "user"
      ? paths.selectedIndividualProfile(userUuid)
      : paths.selectedCopmanyProfile(userUuid)
  return (
    <p>
      <Link to={userLink}>{userName}</Link> {middleText} &nbsp;
      {objectName && objectLink && objectType && (
        <React.Fragment>
          <Link to={objectLink}>{objectName}</Link>
          &nbsp; {objectType}
        </React.Fragment>
      )}
    </p>
  )
}

export const notificationMessageDecoder = (notification) => {
  if (notification.message_type === "system") {
    if (notification.attached_object) {
      if (notification.attached_object.type === "user_application") {
        return renderUserApplicationNotification(notification)
      }
      switch (notification.body) {
        case "opportunity_created": {
          return generateMessage(
            notification.sender.full_name || notification.sender.name,
            notification.sender.type,
            notification.sender.uuid,
            "applied for your",
            notification.attached_object.name,
            paths.opportunityPage(notification.attached_object.uuid),
            "opportunity",
          )
        }

        case "opportunity_created_from_provider": {
          return generateMessage(
            notification.sender.full_name || notification.sender.name,
            notification.sender.type,
            notification.sender.uuid,
            "did not accept your",
            notification.attached_object.name,
            paths.opportunityPage(notification.attached_object.uuid),
            "application",
          )
        }

        case "opportunity_rejected_from_seeker": {
          return generateMessage(
            notification.sender.full_name || notification.sender.name,
            notification.sender.type,
            notification.sender.uuid,
            "declined application for",
            notification.attached_object.name,
            paths.opportunityPage(notification.attached_object.uuid),
            "opportunity",
          )
        }

        case "opportunity_created_invited": {
          return generateMessage(
            notification.sender.full_name || notification.sender.name,
            notification.sender.type,
            notification.sender.uuid,
            "invited you to",
            notification.attached_object.name,
            paths.opportunityPage(notification.attached_object.uuid),
            "opportunity",
          )
        }

        case "individual_likes_your_opportunity":
          return generateMessage(
            notification?.sender?.full_name || notification?.sender?.name,
            notification.sender.type,
            notification.sender.uuid,
            "likes your",
            notification.attached_object.name,
            paths.opportunityPage(notification.attached_object.uuid),
            "opportunity",
          )

        case "individual_unliked_your_opportunity":
          return generateMessage(
            notification?.sender?.full_name || notification?.sender?.name,
            notification.sender.type,
            notification.sender.uuid,
            "unliked your",
            notification.attached_object.name,
            paths.opportunityPage(notification.attached_object.uuid),
            "opportunity",
          )

        case "opportunity_rejected_from_provider": {
          return generateMessage(
            notification.sender.full_name || notification.sender.name,
            notification.sender.type,
            notification.sender.uuid,
            "rejected your",
            notification.attached_object.name,
            paths.opportunityPage(notification.attached_object.uuid),
            "application",
          )
        }

        case "opportunity_accepted_from_provider": {
          return generateMessage(
            notification.sender.full_name || notification.sender.name,
            notification.sender.type,
            notification.sender.uuid,
            "accepted your",
            notification.attached_object.name,
            paths.opportunityPage(notification.attached_object.uuid),
            "application",
          )
        }

        case "attendee_created": {
          return generateMessage(
            notification.sender.full_name || notification.sender?.name,
            notification.sender.type,
            notification.sender?.uuid,
            "wants to attend your",
            notification.attached_object?.name,
            paths.resourcePage(notification.attached_object?.uuid),
            "resource",
          )
        }

        case "attendee_canceled": {
          return generateMessage(
            notification.sender.full_name || notification.sender.name,
            notification.sender.type,
            notification.sender.uuid,
            "will not attend your",
            notification.attached_object.name,
            paths.resourcePage(notification.attached_object.uuid),
            "resource",
          )
        }

        case "your_post_has_a_new_comment": {
          return generateMessage(
            notification.sender.full_name || notification.sender.name,
            notification.sender.type,
            notification.sender.uuid,
            "replied to your",
            notification.attached_object.name,
            paths.communityTopic(notification.attached_object.uuid),
            "question",
          )
        }

        case "your_comment_has_a_new_reply": {
          return generateMessage(
            notification.sender.full_name || notification.sender.name,
            notification.sender.type,
            notification.sender.uuid,
            "replied to your comment to",
            notification.attached_object.name,
            commentedObjectDeterminant(notification).url,
            commentedObjectDeterminant(notification).name,
          )
        }

        case "your_comment_has_a_new_reaction": {
          return generateMessage(
            notification.sender.full_name || notification.sender.name,
            notification.sender.type,
            notification.sender.uuid,
            "reacted to your",
            notification.attached_object.name,
            paths.communityTopic(notification.attached_object.uuid),
            "question",
          )
        }

        case "you_received_a_new_peer_circle_invitation": {
          return generateMessage(
            notification.sender.full_name || notification.sender.name,
            notification.sender.type,
            notification.sender.uuid,
            "invites you to discuss",
            notification.attached_object.name,
            paths.communityTopic(notification.attached_object.uuid),
            "question",
          )
        }

        case "your_peer_circle_invitation_was_accepted": {
          return generateMessage(
            notification.sender.full_name || notification.sender.name,
            notification.sender.type,
            notification.sender.uuid,
            "accepted your invitation to",
            notification.attached_object.name,
            paths.communityTopic(notification.attached_object.uuid),
            "peer circle",
          )
        }

        case "your_peer_circle_invitation_was_declined": {
          return generateMessage(
            notification.sender.full_name || notification.sender.name,
            notification.sender.type,
            notification.sender.uuid,
            "declined your invitation to",
            notification.attached_object.name,
            paths.communityTopic(notification.attached_object.uuid),
            "peer circle",
          )
        }

        case "your_post_has_a_new_reaction": {
          return generateMessage(
            notification.sender.full_name || notification.sender.name,
            notification.sender.type,
            notification.sender.uuid,
            "reacted to your",
            notification.attached_object.name,
            paths.communityTopic(notification.attached_object.uuid),
            "question",
          )
        }
        case "User_likes_your_opportunity":
          return generateMessage(
            notification?.sender?.full_name || notification?.sender?.name,
            notification.sender.type,
            notification.sender.uuid,
            "likes your",
            notification.attached_object.name,
            paths.opportunityPage(notification.attached_object.uuid),
            "opportunity",
          )
        case "User_unliked_your_opportunity":
          return generateMessage(
            notification?.sender?.full_name || notification?.sender?.name,
            notification.sender.type,
            notification.sender.uuid,
            "unliked your",
            notification.attached_object.name,
            paths.opportunityPage(notification.attached_object.uuid),
            "opportunity",
          )

        case "employee_user_invited": {
          const invitedName = notification?.attached_object?.name ||
                              notification?.attached_object?.full_name ||
                              "a new member"
          return generateMessage(
            notification?.sender?.full_name || notification?.sender?.name,
            notification.sender.type,
            notification.sender.uuid,
            `invited ${invitedName} as a team member`,
          )
        }

        case "employee_registered": {
          const memberName = notification?.attached_object?.name ||
                             notification?.attached_object?.full_name ||
                             notification?.sender?.full_name ||
                             notification?.sender?.name ||
                             "A new member"
          const memberUuid = notification?.attached_object?.uuid ||
                             notification?.sender?.uuid
          const memberType = notification?.attached_object?.type ||
                             notification?.sender?.type ||
                             "user"
          return generateMessage(
            memberName,
            memberType,
            memberUuid,
            "has registered and joined the team",
          )
        }

        default: {
          return <p>{notification.body}</p>
        }
      }
    } else {
      switch (notification.body) {
        case "individual_likes_your_company":
          return generateMessage(
            notification?.sender?.full_name || notification?.sender?.name,
            notification.sender.type,
            notification.sender.uuid,
            "likes your profile",
          )

        case "individual_unliked_your_company":
          return generateMessage(
            notification?.sender?.full_name || notification?.sender?.name,
            notification.sender.type,
            notification.sender.uuid,
            "unliked your profile.",
          )

        case "company_provider_likes_your_user":
          return generateMessage(
            notification?.sender?.full_name || notification?.sender?.name,
            notification.sender.type,
            notification.sender.uuid,
            "likes your profile.",
          )

        case "company_provider_unliked_your_user":
          return generateMessage(
            notification?.sender?.full_name || notification?.sender?.name,
            notification.sender.type,
            notification.sender.uuid,
            "unliked your profile.",
          )
        case "User_likes_your_company":
          return generateMessage(
            notification?.sender?.full_name || notification?.sender?.name,
            notification.sender.type,
            notification.sender.uuid,
            "likes your profile.",
          )
        case "User_unliked_your_company":
          return generateMessage(
            notification?.sender?.full_name || notification?.sender?.name,
            notification.sender.type,
            notification.sender.uuid,
            "unliked your profile.",
          )
        case "User_unliked_your_user":
          return generateMessage(
            notification?.sender?.full_name || notification?.sender?.name,
            notification.sender.type,
            notification.sender.uuid,
            "unliked your profile.",
          )
        case "User_likes_your_user":
          return generateMessage(
            notification?.sender?.full_name || notification?.sender?.name,
            notification.sender.type,
            notification.sender.uuid,
            "likes your profile.",
          )
        case "new_administrator_added":
          // Use attached_object (new admin) instead of sender (person who added the admin)
          const newAdminName = notification?.attached_object?.name || 
                               notification?.sender?.full_name || 
                               notification?.sender?.name || 
                               "A new administrator"
          const newAdminUuid = notification?.attached_object?.uuid || 
                               notification?.sender?.uuid
          const newAdminType = notification?.attached_object?.type || 
                              notification?.sender?.type || 
                              "user"
          return generateMessage(
            newAdminName,
            newAdminType,
            newAdminUuid,
            "has been assigned administrative privileges on your account",
          )
        default:
          return <p>{notification.body}</p>
      }
    }
  } else {
    return notification.body
  }
}

const userApplicationNotificationTitle = (body) => {
  const actionMatch = body?.match(/^User application (\w+)/)
  const action = actionMatch?.[1]
  if (!action) return body

  const titles = {
    approved: "Application approved",
    rejected: "Application declined",
    new: "New application submitted",
    updated: "Application updated",
    request_details: "Additional information requested",
  }

  return titles[action] || "Application update"
}

export const notificationTitleDecoder = ({ body }) => {
  if (notificationsHeader[body]) {
    return notificationsHeader[body]
  }

  if (body?.startsWith("User application ")) {
    return userApplicationNotificationTitle(body)
  }

  return body
}

const commentedObjectDeterminant = (notification) => {
  const commentedObject = {}
  switch (notification.attached_object.type) {
    case "question": {
      commentedObject.url = paths.communityTopic(
        notification.attached_object.uuid,
      )
      commentedObject.name = "question"
      break
    }
    case "institutearticle": {
      commentedObject.url = paths.specificInstituteArticle(
        notification.attached_object.uuid,
      )
      commentedObject.name = "article"
      break
    }
    case "inspirationarticle": {
      commentedObject.url = paths.specificInspirationArticle(
        notification.attached_object.uuid,
      )
      commentedObject.name = "article"
      break
    }
    default: {
      commentedObject.name = "unknown attached_object"
    }
  }
  return commentedObject
}
